import Typed from "typed.js";

class typedModule
{
    static run () {

        const toggles = document.querySelectorAll('[data-typed]');
        toggles.forEach((toggle) => {

            const elementOptions = toggle.dataset.typed ? JSON.parse(toggle.dataset.typed) : {};
            const defaultOptions = {
                typeSpeed: 40,
                backSpeed: 40,
                backDelay: 1000,
                loop: true,
                autoInsertCss: false,
            };

            const options = {
                ...defaultOptions,
                ...elementOptions,
            };

            new Typed(toggle, options);
        });

    }
}

export default typedModule;
